export const getters = {
    loadingRestaurant: state => state.loadingRestaurant,
    errorRestaurant: state => state.errorRestaurant,
    restaurant: state => state.restaurant
}